import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FavoriteState } from 'src/app/_shared/state/favorite.state';
import { PropertyState } from 'src/app/workspace/state/property.state';
import { WorkspaceState } from '../../../_shared/state/workspace.state';
import { WorkspaceService } from '../../service/workspace.service';

@Injectable({
  providedIn: 'root',
})
export class PropertyListSheetFacade {
  isDataProcessing = false;

  constructor(
    private favoriteState: FavoriteState,
    private propertyState: PropertyState,
    private workspaceService: WorkspaceService,
    private workspaceState: WorkspaceState
  ) {}

  initiateRender$(): Observable<any> {
    return this.propertyState.initiateRender$;
  }

  isLoading$(): Observable<boolean> {
    return this.workspaceState.isSearchProcessing$;
  }

  get defaultFollowGroup() {
    const followGroups = this.favoriteState.followGroupListValue;
    if (followGroups) {
      const defaultGroup = followGroups.find((el) => el.mode === 'Default');
      return defaultGroup && defaultGroup.id ? [defaultGroup.id] : null;
    } else {
      return null;
    }
  }

  openPropertyDetailsSheet(property) {
    this.workspaceService.openPropertyDetailsSheet(property);
  }

  getFavoriteList$(): Observable<any> {
    return this.favoriteState.favoritePropertyIdList$;
  }
}
